import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IPostLikeLessonById } from '@/Module/Lesson/Model/ApiModel/IPostLikeLessonById';
import type { ILike } from '@/Module/Lesson/Model/DataModel';
import lessonService from '@/Module/Lesson/Service/LessonService';

export const postLikeLessonByIdAction = createAsyncThunk<ILike, Pick<IPostLikeLessonById, 'likeEntityId' | 'likeDislike'>>(
  'lesson/postLike',
  (req, { signal }) => {
    return lessonService
      .postLikeById(
        {
          ...req,
          likeEntityTypeId: 1,
        },
        signal,
      )
      .then(({ data: { data } }) => {
        return data;
      });
  },
);
